import Form from '../../helpers/Form'

export default {
    props: {
        url: {
            required: true,
            type: String
        },

        fields: {
            required: true,
            type: Object
        }
    },

    data () {
        return {
            isBusy: false,
            form: new Form(this.fields)
        }
    },

    methods: {
        submit () {
            if (this.isBusy) {
                return
            }
            this.isBusy = true

            this.form.post(this.url).then((response) => {
                window.location.href = response.redirect_to
            }).catch(() => {
                this.isBusy = false
            })
        }
    }
}
